module.exports = __webpack_public_path__ + "static/media/playIcon.a1f85b77.svg";